// Link to a sub route of a section. A trailing optional param ("home/:tab?") is dropped, so the
// link lands on the section's default page.
export const subRouteLink = (sectionPath, subPath) =>
  `${sectionPath}/${subPath.replace(/\/?:[^/]+\?$/, "")}`;

// The campaign list tab the user was last on (Tracking / Execution / Requested), so going back
// from a campaign page returns to that tab instead of the default one. Kept in memory: it only has
// to survive moving around the app, and a reload goes back to the default tab.
let lastCampaignTab = null;

export const rememberCampaignTab = (tab) => {
  lastCampaignTab = tab;
};

export const campaignHomeLink = () =>
  lastCampaignTab ? `/campaign/home/${lastCampaignTab}` : "/campaign/home";
